import React, { FC, useState } from 'react';
import classes from './SignUpView.module.scss';
import CircleLoader from './CircleLoader';
import Button from './Button';
import { signUp } from '../service/userService';
import { history } from '../reducers/store';

const SignUpView: FC = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [successMessage, setSuccessMessage] = useState<string>();

  const validate = (): string | null => {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address.';
    if (!username || username.length < 3) return 'Username must be at least 3 characters.';
    if (!password || password.length < 6) return 'Password must be at least 6 characters.';
    if (password !== password2) return 'Passwords do not match.';
    return null;
  };

  const handleSubmit = async () => {
    const validationError = validate();
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    try {
      setLoading(true);
      setErrorMessage(undefined);
      const result = await signUp(email, password, username);
      setSuccessMessage(result.message);
    } catch (err: any) {
      const msg = err?.response?.data?.message || 'Registration failed. Please try again.';
      setErrorMessage(Array.isArray(msg) ? msg.join(' ') : msg);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    history.push('/login');
  };

  return (
    <div className={classes.mainCont}>
      <div className={classes.bg}></div>
      <div className={classes.panel}>
        <div className={classes.header}>
          <div className={classes.title}>Create account</div>
        </div>
        <div className={classes.body}>
          {loading && <CircleLoader size={20} />}
          {errorMessage && <div className={classes.error}>{errorMessage}</div>}
          {successMessage ? (
            <div className={classes.success}>
              <p>{successMessage}</p>
              <Button onClick={handleBackToLogin}>Back to login</Button>
            </div>
          ) : (
            <form
              className={classes.form}
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}>
              <label className={classes.label}>
                Email
                <input
                  className={classes.input}
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                />
              </label>
              <label className={classes.label}>
                Username
                <input
                  className={classes.input}
                  type="text"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Choose a display name"
                />
              </label>
              <label className={classes.label}>
                Password
                <input
                  className={classes.input}
                  type="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="At least 6 characters"
                />
              </label>
              <label className={classes.label}>
                Confirm password
                <input
                  className={classes.input}
                  type="password"
                  autoComplete="new-password"
                  value={password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  placeholder="Repeat password"
                />
              </label>
              <div className={classes.btnRow}>
                <Button onClick={handleSubmit} disabled={loading}>
                  Sign up
                </Button>
                <Button secondary onClick={handleBackToLogin}>
                  Back
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignUpView;
